import { makeLazyTranslations } from 'd2/hooks/useTranslations'

export default makeLazyTranslations({
  en: () => import('./translations.en'),
})
